import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';

const SERIF = "'Cormorant Garamond', serif";

const NotFound = () => {
  useEffect(() => {
    document.title = 'Page not found | Archen™';
  }, []);

  return (
    <div className="bg-[#FDF8F3] min-h-screen antialiased flex flex-col" data-testid="not-found-page">
      <Header />
      <main className="flex-1 flex items-center">
        <div className="content-container text-center py-32 md:py-40">
          <p className="text-[#7A5A2E] text-[11px] tracking-[0.24em] uppercase mb-6" data-testid="not-found-code">Error 404</p>
          <h1
            className="mx-auto text-[#1F1812] leading-[1.05] tracking-[-0.02em]"
            style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 'clamp(2.6rem, 5vw, 4.2rem)', maxWidth: '18ch' }}
            data-testid="not-found-title"
          >
            This page could not be found.
          </h1>
          <p className="mt-7 mx-auto text-[#3D3A36] text-[18px] md:text-[20px] leading-[1.6] max-w-[52ch]">
            The link may be out of date or the page may have moved. Let us get you back on track.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              data-testid="not-found-home-link"
              className="inline-flex items-center justify-center bg-[#1F1812] text-white text-[14px] font-medium px-7 py-3.5 rounded-lg hover:bg-[#0F0D0A] transition-colors"
            >
              Back to home
            </Link>
            <Link
              to="/insights"
              data-testid="not-found-insights-link"
              className="inline-flex items-center justify-center border border-[#D8CBB8] text-[#1F1812] text-[14px] font-medium px-7 py-3.5 rounded-lg hover:bg-[#F0E7D9] transition-colors"
            >
              Read the Insights
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
